import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";

export const recommendedFriends = createAsyncThunk("recommendedFriends", async (data) => {
    const response = await axiosInstance.get(`/recommended_users/`, data);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const suggestedFriends = createAsyncThunk("suggestedFriends", async (data) => {
    const response = await axiosInstance.get(`/follow_suggestions/`, data);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const suggestedMyFriendship = createAsyncThunk("suggestedMyFriendship", async (data) => {
    const response = await axiosInstance.get(`/my_friendship_suggestions/`, data);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const removedFriendshipSuggestion = createAsyncThunk("removedFriendshipSuggestion", async (userId, { rejectWithValue }) => {
    const response = await axiosInstance.post(`/remove-suggestion/${userId}/`);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const suggestedContentBasedUser = createAsyncThunk("suggestedContentBasedUser", async (page = 1) => {
    const response = await axiosInstance.get(`/similar-user-suggest/?page=${page}`);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const RecommendationSlice = createSlice({
    name: "Recommendation",
    initialState: {
        loading: false,
        error: null,
        recommendUserData: [],
        suggestedUserData: [],
        myFriendshipSuggestion: [],
        contentBasedUser: [],
        contentBasedUserCount: 0,
        contentBasedUserNext: null,
        contentBasedUserPrevious: null,
    },
    extraReducers: (builder) => {
        // Recommended Friends
        builder.addCase(recommendedFriends.pending, (state) => {
            state.loading = true;
            state.recommendUserData = [];
        });
        builder.addCase(recommendedFriends.fulfilled, (state, action) => {
            state.loading = false;
            state.recommendUserData = action.payload;
        });
        builder.addCase(recommendedFriends.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Follow Suggestion
        builder.addCase(suggestedFriends.pending, (state) => {
            state.loading = true;
            state.suggestedUserData = [];
        });
        builder.addCase(suggestedFriends.fulfilled, (state, action) => {
            state.loading = false;
            state.suggestedUserData = action.payload;
        });
        builder.addCase(suggestedFriends.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // My Friendship Suggestion
        builder.addCase(suggestedMyFriendship.pending, (state) => {
            state.loading = true;
            state.myFriendshipSuggestion = [];
        });
        builder.addCase(suggestedMyFriendship.fulfilled, (state, action) => {
            state.loading = false;
            state.myFriendshipSuggestion = action.payload;
        });
        builder.addCase(suggestedMyFriendship.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Content Based User
        builder.addCase(suggestedContentBasedUser.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(suggestedContentBasedUser.fulfilled, (state, action) => {
            state.loading = false;
            const newResults = action.payload?.results || [];
            // Append new results to existing ones for infinite scroll
            state.contentBasedUser = action.meta.arg > 1
                ? [...state.contentBasedUser, ...newResults]
                : newResults;
            state.contentBasedUserCount = action.payload?.count || 0;
            state.contentBasedUserNext = action.payload?.next;
            state.contentBasedUserPrevious = action.payload?.previous;
        });
        builder.addCase(suggestedContentBasedUser.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        // Content Based User
        builder.addCase(removedFriendshipSuggestion.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(removedFriendshipSuggestion.fulfilled, (state, action) => {
            state.loading = false;
        });
        builder.addCase(removedFriendshipSuggestion.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default RecommendationSlice.reducer;